import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Badge } from "./ui/badge";
import { Tag, MessageSquare, ChevronRight } from "lucide-react";

export default function MySales() {
  const [items, setItems] = useState([]);
  const [threads, setThreads] = useState([]);
  useEffect(() => {
    api.get("/my/sales").then(({ data }) => setItems(data)).catch(() => {});
    api.get("/my/sale-threads").then(({ data }) => setThreads(data)).catch(() => {});
  }, []);
  if (items.length === 0 && threads.length === 0) return null;
  return (
    <div data-testid="my-sales-section">
      <h2 className="font-display text-xl font-bold mb-3 flex items-center gap-2"><Tag className="w-5 h-5 text-amber-400" /> Buy &amp; sell</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((l) => (
          <Link key={l.listing_id} to={`/buy/${l.listing_id}`} data-testid={`my-sale-${l.listing_id}`} className="flex items-center gap-3 p-3 rounded-xl bg-[#131722] border border-slate-800 hover:border-amber-500/40">
            <div className="w-16 h-12 rounded-lg overflow-hidden bg-slate-900 shrink-0">{l.photos?.[0] && <img src={l.photos[0]} alt="" className="w-full h-full object-cover" />}</div>
            <div className="min-w-0 flex-1"><p className="font-semibold truncate">{l.year} {l.make} {l.model}</p><p className="text-xs text-slate-400">${Number(l.asking_price).toLocaleString()} · {l.views} views</p></div>
            <Badge className="bg-slate-800 text-slate-200 text-[10px] uppercase">{l.status}</Badge>
          </Link>
        ))}
        {threads.map((t) => (
          <Link key={t.thread_id} to={`/buy/${t.listing_id}`} data-testid={`my-sale-thread-${t.thread_id}`} className="flex items-center gap-3 p-3 rounded-xl bg-[#131722] border border-slate-800 hover:border-amber-500/40">
            <MessageSquare className="w-4 h-4 text-amber-400 shrink-0" />
            <div className="min-w-0 flex-1"><p className="font-semibold truncate">{t.listing_label}</p><p className="text-xs text-slate-400">with {t.buyer_name} / {t.seller_name} · {t.messages.length} messages</p></div>
            <ChevronRight className="w-4 h-4 text-slate-500" />
          </Link>
        ))}
      </div>
    </div>
  );
}
